/**
 * Gorgias Session Cleanup Monitor
 *
 * This script monitors for authenticated Gorgias sessions and automatically
 * disconnects the customer's browser from the session 15 minutes after
 * authentication starts (GDPR compliance for prescription data).
 *
 * Installation: Add this script to the Shopify theme (e.g., in theme.liquid)
 *
 * Dependencies:
 * - Reads gorgiasAuthStart cookie set by verkkoreseptit.apteekki360.fi
 */

(function () {
    'use strict';

    window.clearGorgias = function () {
        console.log('[Gorgias Cleanup] Clearing all Gorgias localStorage data...');

        const gorgiasKeys = [
            'gorgias.chat-access-token',
            'gorgias.chat-last-opened-date',
            'gorgias.chat-ws-last-connected',
            'gorgias.language-loaded',
            'gorgias.last-received-message-id',
            'gorgias.last-sent-amplitude-event',
            'gorgias.privacy-policy-acknowledged',
            'gorgias.chat-storage-updated-at',
            'gorgias.user-journey-id',
            'gorgias.version',
        ];

        let removedCount = 0;

        gorgiasKeys.forEach((key) => {
            if (localStorage.getItem(key) !== null) {
                localStorage.removeItem(key);
                removedCount++;
            }
        });

        const allKeys = Object.keys(localStorage);
        allKeys.forEach((key) => {
            if (key.startsWith('gorgias.') && !gorgiasKeys.includes(key)) {
                localStorage.removeItem(key);
                removedCount++;
                console.log(`[Gorgias Cleanup] Removed additional key: ${key}`);
            }
        });

        console.log(`[Gorgias Cleanup] Removed ${removedCount} Gorgias localStorage items`);

        if (window.Gorgias && typeof window.Gorgias.chat?.close === 'function') {
            window.Gorgias.chat.close();
            console.log('[Gorgias Cleanup] Closed Gorgias chat widget');
        }

        return removedCount;
    };

    const CLEANUP_INTERVAL_MS = 15 * 60 * 1000;
    const CHECK_INTERVAL_MS = 1 * 1000;

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    function deleteCookie(name) {
        document.cookie = `${name}=; domain=.apteekki360.fi; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=Lax`;
    }

    function checkAndCleanup() {
        const authStart = getCookie('gorgiasAuthStart');
        
        if (!authStart) {
            return;
        }

        const startTime = parseInt(authStart, 10);
        if (isNaN(startTime)) {
            console.warn('[Gorgias Cleanup] Invalid gorgiasAuthStart cookie value:', authStart);
            deleteCookie('gorgiasAuthStart');
            return;
        }

        const elapsed = Date.now() - startTime;
        if (elapsed >= CLEANUP_INTERVAL_MS) {
            console.log('[Gorgias Cleanup] Session expired after 15 minutes - clearing sensitive data session');

            if (typeof window.clearGorgias === 'function') {
                try {
                    window.clearGorgias();
                    deleteCookie('gorgiasAuthStart');
                    console.log('[Gorgias Cleanup] Successfully cleared session and removed cookie');
                } catch (error) {
                    console.error('[Gorgias Cleanup] Error calling clearGorgias():', error);
                }
            } else {
                console.error('[Gorgias Cleanup] clearGorgias() function not found - cannot clear session');
                deleteCookie('gorgiasAuthStart');
            }
        } else {
            const remainingMinutes = Math.ceil((CLEANUP_INTERVAL_MS - elapsed) / 60000);
            //console.log(`[Gorgias Cleanup] Authenticated session active. Cleanup in ${remainingMinutes} minutes`);
        }
    }

    function addRecChatCustomization() {
        const observer = new MutationObserver((mutations, obs) => {
            const chatWindow = document.getElementById('chat-window');
            if (chatWindow) {
                addKlosObserver();
                obs.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        function addKlosObserver() {
            let myIframe, iframeDoc;
            let waitForIt = window.setInterval(function () {
                myIframe = document.getElementById('chat-window');
                iframeDoc = myIframe.contentDocument || myIframe.contentWindow.document;
                if (iframeDoc && iframeDoc.childElementCount > 0) { // Gorgias does some weird stuff with iframe loading, so we'll check until document is getting populated, readystate does not matter, and there is no rush
                    iframeDoc.head.insertAdjacentHTML("beforeend", `<style>.klos { list-style-type: none !important; float:left; } .klos li {margin-bottom:8px;} .klos button { padding:5px; width:3.5rem; } span:has(>svg) {display: none !important; } div[id] div>ul:not([class="klos"]) { display: none; } .pii { display: none; } #toimitusvaihtoehdot { display: block; }</style>`);
                    const klosObserver = new MutationObserver((mutations, klobs) => {
                        mutations.forEach((mutation) => {
                            //console.log('Change in iframe:', mutation);
                            mutation.addedNodes.forEach((node) => {
                                if (node.nodeType === 1 && node.querySelector('textarea')) {
                                    if (iframeDoc.querySelectorAll('.klos button').length > 0 && iframeDoc.querySelectorAll('.klos button[disabled]').length == 0) {
                                        iframeDoc.querySelectorAll('.klos button').forEach(function(el) {
                                            el.addEventListener('click', function() {
                                                window.parent.GorgiasChat.setCurrentInput(el.innerText);
                                                iframeDoc.querySelector('#chat-message-input-send-button').click();
                                                iframeDoc.querySelectorAll('.klos button').forEach(ele => {ele.disabled = true;});
                                            });
                                        });
                                        node.querySelector('div[data-testid="footer-component"]').style.display = 'none';
                                        //klobs.disconnect();
                                    }
                                    if (iframeDoc.querySelectorAll('.pii').length > 0) {
                                        node.querySelector('div[data-testid="footer-component"]').classList.add("pii");
                                    }
                                }
                                if (node.nodeType === 1 && node.innerText.indexOf('Kirjoita alle haluamasi reseptil') > -1 && !getCookie("gorgiasAuthStart")) {
                                    node.classList.add("pii");
                                    let authCheck = setInterval(function() {
                                        if (getCookie("gorgiasAuthStart")) {
                                            iframeDoc.querySelectorAll(".pii").forEach(el => {el.classList.remove("pii")});
                                            clearInterval(authCheck);
                                        }
                                    }, 500);
                                }
                            });
                        });
                    });
                    klosObserver.observe(iframeDoc.body, {
                        childList: true,
                        subtree: true
                    });
                    clearInterval(waitForIt);
                }
            }, 500);
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            checkAndCleanup();
            addRecChatCustomization();
            setInterval(checkAndCleanup, CHECK_INTERVAL_MS);
        });
    } else {
        checkAndCleanup();
        addRecChatCustomization();
        setInterval(checkAndCleanup, CHECK_INTERVAL_MS);
    }

    console.log('[Gorgias Cleanup] Monitor initialized - checking every minute');
})();
